import ShowChartIcon from "@mui/icons-material/ShowChart";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material";

const GraphPlug = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        width: "100%",
        height: 260,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: theme.palette.grey[500],
        borderRadius: 2,
        marginTop: 2,
      }}
    >
      <ShowChartIcon style={{ fontSize: 104 }} color={"info"} />
    </Box>
  );
};

export default GraphPlug;
